import { useState } from "react";
import { Link, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { user, login, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={location.state?.from || "/dashboard"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form);
      toast.success("Selamat datang kembali!");
      navigate(location.state?.from || "/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Masuk ke akun Anda"
      subtitle="Lanjutkan analisis bisnis Anda."
      footer={<>Belum punya akun? <Link to="/register" className="font-semibold text-brand hover:underline" data-testid="link-register">Daftar gratis</Link></>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        {error && <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="login-error">{error}</div>}
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required autoComplete="email" data-testid="login-email"
            className="mt-1.5 h-11" placeholder="nama@email.com"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password">Password</Label>
            <Link to="/forgot-password" className="text-sm text-brand-accent hover:underline" data-testid="link-forgot">Lupa password?</Link>
          </div>
          <div className="relative mt-1.5">
            <Input id="password" type={show ? "text" : "password"} required autoComplete="current-password" data-testid="login-password"
              className="h-11 pr-10" placeholder="••••••••"
              value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-muted" aria-label="Tampilkan password">
              {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
            </button>
          </div>
        </div>
        <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full h-11 bg-brand hover:bg-brand-hover">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Masuk"}
        </Button>
      </form>
    </AuthShell>
  );
}
